import CityPageTemplate from "../city-template/CityPageTemplate";
import { minneapolisConfig } from "./data";

export default function MinneapolisPage() {
  return <CityPageTemplate config={minneapolisConfig} />;
}